import { render } from "./WoTPropertyForm.vue?vue&type=template&id=a6824d7e"
import script from "./WoTPropertyForm.vue?vue&type=script&lang=js"
export * from "./WoTPropertyForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__